const STUDENT_CONFLICT_TYPES = new Set([
  "student_double_booked",
  "student_conflicting_periods",
  "teacher_student_restriction",
  "student_student_restriction",
]);

export const filterConflictsForReportScope = ({
  conflicts = [],
  reportScope = null,
  sections = [],
  courses = [],
}) => {
  if(!reportScope || !reportScope.restrict_to_allowed_ids) return conflicts;

  const allowed_department_ids = new Set((reportScope.allowed_department_ids || []).map(department_id => `${department_id}`));
  const sections_by_id = sections.reduce((results, section) => {
    results[`${section.section_id}`] = section;
    return results;
  }, {});
  const courses_by_id = courses.reduce((results, course) => {
    results[`${course.course_id}`] = course;
    return results;
  }, {});

  const sectionCourseIsInScope = (section) => {
    if(!section || allowed_department_ids.size === 0) return false;

    const course_info = courses_by_id[`${section.course_id}`];
    const course_departments = Array.isArray(course_info?.departments) ? course_info.departments : [];
    return course_departments.some(department_id => allowed_department_ids.has(`${department_id}`));
  };

  return conflicts.filter((conflict) => {
    if(STUDENT_CONFLICT_TYPES.has(conflict.type)) return false;

    const conflict_section_ids = Array.isArray(conflict.sections) ? conflict.sections : [];
    return conflict_section_ids.some(section_id => sectionCourseIsInScope(sections_by_id[`${section_id}`]));
  });
};
